<template>
  <div>
    <CRow>
      <CCol sm="12">
        <WarehousesTable
          :items="warehouses"
          hover
          striped
          border
          small
          fixed
          caption="Almacenes"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import WarehousesTable from '../../components/warehouses/WarehousesTable.vue'
import ws from '../../services/warehouses';
import store from '../../store'

export default {
  name: 'Warehouses',
  components: { WarehousesTable },
  data: function () {
		return {
            warehouses: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.warehouses = response.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.warehouses = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
